<template>
  <CmsTemplate :pageName="'about'" :pageTitle="$t('commons.about')"></CmsTemplate>
</template>
<script>
import CmsTemplate from '@/pages/portal/CmsTemplate'
export default {
  name: 'AboutPage',
  components: { CmsTemplate }
}
</script>



// WEBPACK FOOTER //
// AboutPage.vue?c987ac70